

export abstract class BasePlot {
  public key: string;
  protected width: number;
  protected height: number;
  protected container: HTMLElement;
  constructor(key: string, container: HTMLElement, width: number, height: number) {
    this.key = key;
    this.container = container;
    this.width = width;
    this.height = height;
  }



  abstract update(data: Array<Array<number> | number>): void;
}
